import * as actionTypes from './constants';


const initialState = {
	postComment: {
		loadingStatus: null,
		error: null,
	},
	deleteComment: {
		loadingStatus: null,
		error: null,
	},
	comments: {
		data: [],
		error: null,
		loadingStatus: null,
	},
	selectedCause: null,
	isPreselectedCause: false,
	currentEventId: null,
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_COMMENTS:
			return {
				...state,
				comments: {
					data: action.data,
					error: action.error,
					loadingStatus: action.loadingStatus,
				},
				postComment: { ...state.postComment, error: null },
				deleteComment: { ...state.deleteComment, error: null },
			};
		case actionTypes.POST_EVENT_COMMENT:
			return {
				...state,
				postComment: {
					loadingStatus: action.loadingStatus,
					error: action.error,
				},
			};
		case actionTypes.DELETE_COMMENT: {
			return {
				...state,
				deleteComment: {
					loadingStatus: action.loadingStatus,
					error: action.error,
				},
			};
		}
		case actionTypes.SET_SELECTED_CAUSE:
			return {
				...state,
				selectedCause: action.cause
			};
		case actionTypes.SET_PRESELECTED_CAUSE:
			return {
				...state,
				isPreselectedCause: action.isPreselected
			};
		case actionTypes.INITIALIZE_EVENT_CAUSE_STATE:
			return {
				...state,
				selectedCause: action.cause,
				isPreselectedCause: action.isPreselected,
				currentEventId: action.eventId
			};
		case actionTypes.CLEAR_SELF_EVALUATION_STORE:
			return initialState;
		default:
			return state;
	}
};
